import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import QRCodeStyling, {
  CornerDotType,
  CornerSquareType,
  DotType,
  DrawType,
  Mode,
  TypeNumber,
  ErrorCorrectionLevel,
} from 'qr-code-styling'

import Logo from '@/assets/UniversalProfiles_Apps_Logo_128px.png'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCodeShow',
  props: {
    value: {},
    size: {}
  },
  setup(__props: any) {

const qrCodeRef = ref()
const props = __props

const appStore = useAppStore()

onMounted(() => {
  const options = {
    width: props.size,
    height: props.size,
    type: 'canvas' as DrawType,
    data: props.value,
    image: Logo,
    qrOptions: {
      typeNumber: 0 as TypeNumber,
      mode: 'Byte' as Mode,
      errorCorrectionLevel: 'H' as ErrorCorrectionLevel,
    },
    imageOptions: {
      hideBackgroundDots: true,
      imageSize: 0.4,
      margin: 20,
      crossOrigin: 'anonymous',
    },
    dotsOptions: {
      type: 'extra-rounded' as DotType,
    },
    backgroundOptions: {
      color: '#ffffff',
    },
    cornersSquareOptions: {
      color: '#35495E',
      type: 'extra-rounded' as CornerSquareType,
    },
    cornersDotOptions: {
      color: '#35495E',
      type: 'dot' as CornerDotType,
    },
    cornersSquareOptionsHelper: {
      colorType: {
        single: true,
        gradient: false,
      },
    },
    cornersDotOptionsHelper: {
      colorType: {
        single: true,
        gradient: false,
      },
    },
    backgroundOptionsHelper: {
      colorType: {
        single: true,
        gradient: false,
      },
    },
  }
  const qr = new QRCodeStyling(options)
  qr.append(qrCodeRef.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ClipboardCopy, {
    value: _ctx.value,
    "has-hover-text": false,
    style: _normalizeStyle({ width: `${_ctx.size}px` }),
    "offset-distance": "0",
    placement: "top",
    class: "qr-code qr-image"
  }, {
    default: _withCtx(() => [
      _createVNode(ProfilePicture, {
        "frontend-profile": _unref(appStore).currentProfile,
        class: "profile-pix",
        size: "medium"
      }, null, 8 /* PROPS */, ["frontend-profile"]),
      _createElementVNode("div", {
        "data-testid": "qrContainer",
        ref_key: "qrCodeRef",
        ref: qrCodeRef
      }, null, 512 /* NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["value", "style"]))
}
}

})